/*
 * @Descripttion: desc
 * @Author: zc
 * @Date: 2023-01-11 12:55:41
 * @LastEditors: zc
 * @LastEditTime: 2024-10-11 11:18:26
 */
var router = [{
  path: '/',
  name: 'home',
  redirect: '/setting',
  meta: {
    title: '首页',
    noCache: true,
    moreFlag: true
  }
}];
export default router;